module.exports = __webpack_public_path__ + "media/images/pic/saska/hero-kids-1c07ce1b60d9f7afbee96d9898087433.svg";